import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import LoadingSpinner from '../../../components/LoadingSpinner'
import { dialogEmptyStateTextSx } from '../../../constants/dialogSx'
import {
  RBAC_BULK_REASSIGN_EMPTY_STATE_MESSAGE,
  RBAC_BULK_REASSIGN_LOADING_TEXT,
  RBAC_BULK_REASSIGN_MIN_VISIBLE_ROWS,
  RBAC_BULK_REASSIGN_ROW_MIN_HEIGHT,
  rbacBulkReassignListSx
} from './constants'
import RbacBulkReassignUserRow from './RbacBulkReassignUserRow'

export default function RbacBulkReassignUsersList({
  users,
  loadingUsers,
  loadingMore,
  selectedIds,
  roleByUserId,
  rowErrors,
  roles,
  fixedRole,
  hasFixedRole,
  onToggleUser,
  onRoleChange,
  onScroll
}) {
  return (
    <Box sx={rbacBulkReassignListSx} onScroll={onScroll}>
      {loadingUsers ? (
        <Box
          sx={{
            minHeight: RBAC_BULK_REASSIGN_MIN_VISIBLE_ROWS * RBAC_BULK_REASSIGN_ROW_MIN_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <LoadingSpinner text={RBAC_BULK_REASSIGN_LOADING_TEXT} />
        </Box>
      ) : users.length === 0 ? (
        <Box
          sx={{
            minHeight: RBAC_BULK_REASSIGN_MIN_VISIBLE_ROWS * RBAC_BULK_REASSIGN_ROW_MIN_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            px: 2
          }}
        >
          <Typography sx={dialogEmptyStateTextSx}>
            {RBAC_BULK_REASSIGN_EMPTY_STATE_MESSAGE}
          </Typography>
        </Box>
      ) : (
        <>
          {users.map((user) => {
            const userId = String(user.id)

            return (
              <RbacBulkReassignUserRow
                key={user.id}
                user={user}
                selected={selectedIds.has(userId)}
                roles={roles}
                fixedRole={fixedRole}
                hasFixedRole={hasFixedRole}
                rowError={rowErrors[userId]}
                selectedRoleIds={roleByUserId[userId] || []}
                onToggleUser={onToggleUser}
                onRoleChange={onRoleChange}
              />
            )
          })}
          {loadingMore ? (
            <Box
              sx={{
                py: 1.5,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <LoadingSpinner text={RBAC_BULK_REASSIGN_LOADING_TEXT} />
            </Box>
          ) : null}
        </>
      )}
    </Box>
  )
}
